import React, {useRef} from 'react';
// import { Link } from 'react-router-dom';
// Import Swiper
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, Navigation} from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';

const products = [
    {
        id: 1,
        category: 'Basil Lemonade',
        title: 'Basil Lemonade',
        description: 'Fresh with no preservatives',
        image: '/images/3.png',
        slug: 'greek-yogurt',
    },
    {
        id: 2,
        category: 'Blueberry fruit yogurt',
        title: 'Blueberry fruit yogurt.',
        description: 'Real fruit blends with smooth yogurt.',
        image: '/images/fruit yogurt blueberry.png',
        slug: 'fruit-yogurt',
    },
    {
        id: 3,
        category: 'Punjabi Lassi',
        title: 'Punjabi Lassi.',
        description: 'On-the-go nutrition made easy.',
        image: '/images/4.png',
        slug: 'drinkable-yogurt',
    },
    {
        id: 4,
        category: 'Double Chocolate',
        title: 'Double Chocolate.',
        description: 'Traditional refreshment with a modern twist.',
        image: '/images/Double CHocolate.png',
        slug: 'lassi',
    },
    {
        id: 5,
        category: 'Iced tea',
        title: 'Peach iced tea.',
        description: 'Activated peach iced tea.',
        image: '/images/2.png',
        slug: 'flavoured-milk',
    },
    {
        id: 6,
        category: 'Cold Coffees',
        title: 'Cold Coffee',
        description: 'Premium blended Coffee.',
        image: '/images/5.png',
        slug: 'plain-greek',
    },
    {
        id: 7,
        category: 'Fruit Yogurt',
        title: 'Strawberry Bliss',
        description: 'Real strawberries blended to perfection.',
        image: '/images/strawbeery.png',
        slug: 'strawberry',
    },
    {
        id: 8,
        category: 'Drinkable',
        title: 'Mango Lassi',
        description: 'Exotic mango flavor explosion.',
        image: '/images/mango lassi.png',
        slug: 'mango',
    },
    {
        id: 9,
        category: 'Fruit Yogurt',
        title: 'Mango Fruit Yogurt',
        description: 'Fruit on the bottom.',
        image: '/images/mango-fruit.png',
        slug: 'mango',
    }
];

const ProductSlider = () => {
    const navigationPrevRef = useRef(null);
    const navigationNextRef = useRef(null);

    return (
        <section id="products" className="w-full bg-white py-8 md:py-10 lg:py-12 overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 mb-8 md:mb-10">
                {/* Section Header */}
                <div className="flex flex-col md:flex-row md:items-end md:justify-between">
                    <div>
                        <p className="text-[#DE0000] uppercase tracking-[0.2em] text-xs font-semibold mb-2 md:mb-3">
                            OUR PRODUCTS
                        </p>
                        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-serif text-gray-900 max-w-2xl">
                            <span className="block sm:inline">Crafted with care,</span>{' '}
                            <span className="block sm:inline text-[#DE0000] whitespace-nowrap">made for you</span>
                        </h2>
                    </div>

                    {/* Navigation Arrows - Hide on mobile? Optional */}
                    <div className="hidden sm:flex items-center gap-3 mt-6 md:mt-0">
                        <button
                            ref={navigationPrevRef}
                            className="w-12 h-12 rounded-full border border-gray-200 flex items-center justify-center hover:bg-gray-50 transition-all group"
                            aria-label="Previous slide"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="group-hover:scale-110 transition-transform">
                                <path d="M15 19L8 12L15 5" stroke="#1A3C34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                        <button
                            ref={navigationNextRef}
                            className="w-12 h-12 rounded-full border border-gray-200 flex items-center justify-center hover:bg-gray-50 transition-all group"
                            aria-label="Next slide"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="group-hover:scale-110 transition-transform">
                                <path d="M9 5L16 12L9 19" stroke="#1A3C34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            {/* Full Width Swiper Slider */}
            <div className="w-full pl-4 sm:pl-6 md:pl-10 lg:pl-16 xl:pl-24">
                <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={12}
                    slidesPerView={1.2}
                    navigation={{
                        prevEl: navigationPrevRef.current,
                        nextEl: navigationNextRef.current,
                    }}
                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true
                    }}
                    loop={true}
                    speed={800}
                    breakpoints={{
                        480: {
                            slidesPerView: 1.5,
                            spaceBetween: 12,
                        },
                        640: {
                            slidesPerView: 1.8,
                            spaceBetween: 12,
                        },
                        768: {
                            slidesPerView: 2.2,
                            spaceBetween: 12,
                        },
                        1024: {
                            slidesPerView: 2.8,
                            spaceBetween: 12,
                        },
                        1280: {
                            slidesPerView: 3.2,
                            spaceBetween: 12,
                        },
                        1536: {
                            slidesPerView: 3.8,
                            spaceBetween: 12,
                        }
                    }}
                    onInit={(swiper) => {
                        swiper.params.navigation.prevEl = navigationPrevRef.current;
                        swiper.params.navigation.nextEl = navigationNextRef.current;
                        swiper.navigation.init();
                        swiper.navigation.update();
                    }}
                    className="!overflow-visible"
                >
                    {products.map((product) => (
                        <SwiperSlide key={product.id}>
                            <div className="bg-white shadow-sm hover:shadow-xl transition-all duration-500 hover:-translate-y-2">
                                {/* Image Container */}
                                <div className="relative aspect-[4/5] overflow-hidden bg-[#F8F4F0]">
                                    <img
                                        src={product.image}
                                        alt={product.title}
                                        className="w-full h-full object-cover transition-transform duration-700 hover:scale-110"
                                        loading="lazy"
                                    />
                                </div>

                                {/* Content */}
                                <div className="p-4 sm:p-6 bg-[#F8F4F0]">
                                    <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-1 sm:mb-2 line-clamp-1">
                                        {product.title}
                                    </h3>
                                    <p className="text-gray-600 text-xs sm:text-sm mb-3 sm:mb-4 line-clamp-2">
                                        {product.description}
                                    </p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
};

export default ProductSlider;